import React from "react";

function Contact() {
  return (
    <div className="flex justify-center items-center h-96">
      <h1 className="text-4xl font-extralight">Coming Soon ........</h1>
    </div>
  );
}

export default Contact;
